import * as types from '../constants/actionTypes';
import initialState from './initialState';
import Immutable from 'seamless-immutable';
import { GALLERY_STATUS } from '../constants/constants';

/* Note */
/* Params: isLoadMore to check user have load more yet */
export default function privateAlbumAccess(state = initialState.hiddenList, action) {
  switch (action.type) {
    case types.UPDATE_PRIVATE_ALBUM_ACCESS_STATE: {
      return state.merge({ ...action.data });
    }
    case types.GET_PRIVATE_ALBUM_ACCESS_SUCCESS: {
      const { data } = Immutable.asMutable(state);
      let updateParams = {};
      let updateData = action.data.filter(item => {
        let unValid = [];
        item.openGalleries?.forEach(gallery => unValid.push(gallery.status));
        return !unValid.every(element => element === 'Rejected');
      });
      updateParams = {
        isLoading: false,
        isCalled: true,
        data: action.params && action.params.isLoadMore ? [...data, ...updateData] : updateData,
        isHasMore: !(action.data instanceof Array && action.data.length < 25),
        page: action.params.page,
        isCallingLoadMore: false,
      };
      return state.merge({ ...updateParams });
    }
    case types.UPDATE_PRIVATE_ALBUM_ACCESS_SUCCESS: {
      const { data } = Immutable.asMutable(state);
      if (action.openGalleries && action.openGalleries.length > 1) {
        const g = action.openGalleries.filter((item, index) => item.access);
        return state.setIn(['data', action.index, 'openGalleries'], g);
      }
      const d = data.filter((item, index) => index !== action.index);
      return state.setIn(['data'], d);
    }
    case types.UPDATE_PRIVATE_ALBUM_STATUS_SUCCESS: {
      let { galleryId } = action;
      let _openGalleries = action.openGalleries.map(g => {
        return {
          ...g,
          status: g.status === GALLERY_STATUS.PENDING || (action.allowUpdateStatus && g.galleryId === galleryId) ? action.status : g.status,
        };
      });
      return state.setIn(['data', [action.index], 'openGalleries'], _openGalleries);
    }
    case types.USER_LOGOUT_SUCCESS: {
      const reset = {
        data: [],
        page: 1,
        isLoading: false,
        isHasMore: true,
      };
      return state.merge({
        ...reset,
      });
    }
    case types.RESET_ALL_DATA:
      return state.merge({
        isLoading: false,
        isCalled: false,
        data: [],
        isHasMore: true,
        page: 1,
        isCallingLoadMore: false,
      });

    default:
      return state;
  }
}
